import React, {useEffect, useMemo, useState} from 'react';
import {ReactComponent as Search} from '../../assets/icons/search_icon20x20.svg';
import {ReactComponent as Question} from '../../assets/icons/help_icon20x20.svg';
// import {ReactComponent as SearchMobile} from '../../assets/icons/search_icon_25x25_mobile.svg';
import {ReactComponent as QuestionMobile} from '../../assets/icons/help_icon20x20.svg';
import {ReactComponent as XCLogoMobileIcon} from '../../assets/icons/XC_info_icon.svg';
import {ReactComponent as Basket} from '../../assets/icons/my_list_icon25x25.svg';
import {ReactComponent as Fullscreen} from '../../assets/icons/full_screen_icon20x20.svg';
import {ReactComponent as Toc} from '../../assets/icons/content_icon20x20.svg';
import {ReactComponent as ShareIcon} from "../../assets/icons/share_icon20x20.svg";
import {ReactComponent as ShareIconMobile} from "../../assets/icons/share_icon20x20.svg";
import {ReactComponent as GoHomeIcon} from "../../assets/icons/home_icon20x20.svg";
// import {ReactComponent as FullscreenMobile} from '../../assets/icons/fullscreen_icon_25x25_mobile.svg';
import {ReactComponent as TocMobile} from '../../assets/icons/content_icon20x20.svg';
// import { ReactComponent as Toc } from '../../assets/icons/TOC.svg';
// import {Pagination} from '../../com/pagination';
import {useDispatch, useSelector} from 'react-redux';
// import {addSelectedSpot, removeSelectedSpot} from '../../store/actionsCreator/selectedSpotActionsCreator';
import {
    // toggleMultipage,
    // toggleThumbnails,
    toggleSearch,
    toggleBasket,
    toggleHelpScreen,
    toggleToc, toggleShareMenu, toggleContactUsPopup
} from '../../store/actionsCreator/controlsActionsCreator'
import {IAppState, IDetailsBranch, ISelectedSpot} from '../../store/models';
import {IFlyerRuntime, IFreeItemsInPromo, PromosState} from '../../dtos/flyer';

import {zoomIn} from '../../store/actionsCreator/zoomActionCreators';
// import useMediaQuery from "@material-ui/core/useMediaQuery";
import {
    findCurrentTranslateLabel,
    getTotalItems,
    openUrlInAnotherTab
} from "../../com/globalsFunctions/globalFunctions";
import {removeSelectedSpot} from '../../store/actionsCreator/selectedSpotActionsCreator';
import {Box, Button, Grid, Typography} from "@mui/material";
import {makeStyles} from "@mui/styles";
import {isMobile, isTablet} from 'react-device-detect';
import {toggleDetailsAction} from "../../store/actionsCreator/detailsActionsCreator";
import {useHistory} from "react-router-dom";
import {setAddToMyListOneItemData} from "../../store/actionsCreator/addToMyListOneItemActionsCreator";
import tinycolor from "tinycolor2";


const useStyles = makeStyles(() => ({
    actionsMobileWrapper: (props: any) => ({
        height: '50px',
        backgroundColor: props.primaryColorHex ? props.primaryColorHex : '#C32E43',
        direction: props.direction,
        '& .MuiBox-root': {
            height: `100%`,
            display: `flex`,
            justifyContent: `center`,
            color: `white`,
        },
        '& .MuiButton-root': {
            // width: '40px',
            // height: '40px',
            paddingTop: `2px`,
            display: `flex`,
            alignItems: 'center',
            flexDirection: `column`,
            textTransform: `capitalize`,
            '& > .MuiTypography-root': {
                fontFamily: `${props.fontFamily}`,
                color: props.isLightGuiColor ? props.fontsGuiColor : `#FFFFFF`,
                fontSize: `14px`,
                textOverflow: `ellipsis`,
                overflow: `hidden`,
                whiteSpace: `nowrap`,
                maxWidth: `100%`,
                // marginTop: `4px`
            },
            "&:not(.tocActionButton) svg": {
                // fill: props.isLightGuiColor ? `#2A2A2A` : `#FFFFFF`,
                '& path': {
                    stroke: props.isLightGuiColor ? props.fontsGuiColor : `#FFFFFF`,
                    // stroke: props.primaryColorHex
                },
                '& circle': {
                    stroke: props.isLightGuiColor ? props.fontsGuiColor : `#FFFFFF`,
                    // stroke: props.primaryColorHex
                }
            },

            '&.tocActionButton svg': {
                '& path': {
                    fill: props.isLightGuiColor ? props.fontsGuiColor : `#FFFFFF`,
                    // stroke: props.primaryColorHex
                },
                '& circle': {
                    fill: props.isLightGuiColor ? props.fontsGuiColor : `#FFFFFF`,
                    // stroke: props.primaryColorHex
                }
            },
            '&.Mui-disabled': {
                opacity: `0.5`
            }
        }
    }),
    actionButton: {
        '&.Mui-disabled': {
            opacity: '0.7',
            // backgroundColor: '#d4d4d4'
        }
    },
    actionsWrapper: {
        display: `flex`,
        justifyContent: "flex-end",
        '& > div': {
            margin: `0 10px`
        }
    },
    actionBox: (props: any) => ({
        display: 'flex',
        justifyContent: 'center',
        height: '100%',
        '& > button': {
            display: `flex`,
            alignItems: 'center',
            flexDirection: `column`,
            textTransform: `capitalize`,
            minWidth: `100%`,
            minHeight: `100%`,
            // minWidth: `50px`,
            '& > .MuiTypography-root': {
                color: props.isLightGuiColor ? props.fontsGuiColor : `#FFFFFF`,
                // color: `#ffffff`,
                fontSize: `14px`,
                textOverflow: `ellipsis`,
                overflow: `hidden`,
                whiteSpace: `nowrap`,
                maxWidth: `100%`,
                lineHeight: `18px`,
                marginTop: `5px`,
                fontFamily: `${props.fontFamily}`
            }
        }
    }),
    actionDesktopWrapper: (props: any) => ({
        '& .MuiButton-root': {
            minWidth: '50px',
            // height: '40px',
            padding: '0.4em',

            '&.homeUrl': {
                direction: `ltr`,
                '& .MuiTypography-root': {
                    direction: props.direction,
                }
            },
            '&.isActiveActionBtn': {
                backgroundColor: '#ffffff66'
            },
            "&:not(.tocActionButton) svg": {
                // fill: props.isLightGuiColor ? `#2A2A2A` : `#FFFFFF`,
                '& path': {
                    stroke: props.isLightGuiColor ? props.fontsGuiColor : `#FFFFFF`,
                    // stroke: props.primaryColorHex
                },
                '& circle': {
                    stroke: props.isLightGuiColor ? props.fontsGuiColor : `#FFFFFF`,
                    // stroke: props.primaryColorHex
                }
            },

            '&.tocActionButton svg': {
                '& path': {
                    fill: props.isLightGuiColor ? props.fontsGuiColor : `#FFFFFF`,
                    // stroke: props.primaryColorHex
                },
                '& circle': {
                    fill: props.isLightGuiColor ? props.fontsGuiColor : `#FFFFFF`,
                    // stroke: props.primaryColorHex
                }
            },
            '&:hover': {
                backgroundColor: '#ffffffBF',
                '& > .MuiTypography-root': {
                    color: props.isLightGuiColor ? `${props.fontsGuiColor}80` : `#FFFFFF`,
                },
                '&:not(.tocActionButton) svg': {
                    '& path': {
                        stroke: props.isLightGuiColor ? `${props.fontsGuiColor}80` : `#FFFFFF`,
                        // stroke: props.primaryColorHex
                    },
                    '& circle': {
                        stroke: props.isLightGuiColor ? `${props.fontsGuiColor}80` : `#FFFFFF`,
                        // stroke: props.primaryColorHex
                    }
                },
                '&.tocActionButton svg': {
                    '& path': {
                        fill: props.isLightGuiColor ? `${props.fontsGuiColor}80` : `#FFFFFF`,
                        // stroke: props.primaryColorHex
                    },
                    '& circle': {
                        fill: props.isLightGuiColor ? `${props.fontsGuiColor}80` : `#FFFFFF`,
                        // stroke: props.primaryColorHex
                    }

                }
            },
            '&.Mui-disabled': {
                opacity: `0.5`
            }
        }
    }),
    myBasketButton: {
        // width: `45px!important`,
        height: `60px!important`
    },
    numberOfMyListItems: (props: any) => ({
        position: `absolute`,
        background: `${props.primaryColorHex}`,
        color: props.isLightGuiColor ? props.fontsGuiColor : `#ffffff`,
        border: props.isLightGuiColor ? `2px solid ${props.fontsGuiColor}` : `2px solid #ffffff`,
        borderRadius: `5px`,
        minWidth: `30px`,
        top: `-4px`,
        right: `-22px`,
    })
}))


// type Item = {
// 	spotItem: IFlyerRuntimePageSpotItem;
// 	count: number;
// }

type Props = {
    openFullScreen: () => void;
}

export const Actions: React.FC<Props> = ({openFullScreen}) => {
    // const [spot, index, event] = [selectedSpot.spot, selectedSpot, selectedSpot!];
    const {spot} = useSelector<IAppState, ISelectedSpot>(state => state.selectedSpot);
    const dispatch = useDispatch();
    // const isActionsVisible = showThumbnails || showSearch || showBasket || Boolean(selectedSpot.spot) || showCheckout;
    const {
        showSearch,
        showBasket,
        isHelpScreen,
        shareMenu,
        isTocOpen,
        isPortraitView
    } = useSelector((state: IAppState) => state.controlsBranch);
    const {data} = useSelector((state: IAppState) => state.flyersBranch);
    const flyerBasic = useSelector((state: IAppState) => state.flyerBranchBasic.data);
    const isLightGuiColor = tinycolor(flyerBasic?.primaryColorRgb).isLight();
    const fontsGuiColor = flyerBasic?.fontsColorRgb || "#000000";

    const flyerBranch = useSelector<IAppState, IFlyerRuntime | null>((state) => state.flyersBranch.data);
    const {myListState} = useSelector((state: IAppState) => state);
    const [promos, setPromos] = useState<PromosState[]>(myListState.promos);
    const [freeItems, setFreeItems] = useState<IFreeItemsInPromo[]>(myListState.benefitItems)
    const detailsBranch = useSelector<IAppState, IDetailsBranch | null>(state => state.detailsBranch);
    const {addToMyListOneItemData} = useSelector((state: IAppState) => state);
    const flyerType = flyerBranch?.typeCode;


    // translate captions
    const fullScreenTitle = findCurrentTranslateLabel(108, 'Full Screen View with Auto-Flip', data)
    const searchTitle = findCurrentTranslateLabel(109, 'Search', data)
    const helpTitle = findCurrentTranslateLabel(181, 'Help', data)
    const infoTitle = findCurrentTranslateLabel(644, 'Info', data)
    const shareTitle = findCurrentTranslateLabel(114, 'Share', data)
    const TocTitle = findCurrentTranslateLabel(187, 'Table Of Contents', data)
    const myBasketTitle = findCurrentTranslateLabel(137, 'My Basket', data);
    const contentTitle = findCurrentTranslateLabel(187, 'Contents', data);
    const shareTextLabel = findCurrentTranslateLabel(628, "Take a look at", data);
    const homeUrlLabel = findCurrentTranslateLabel(629, "Home", data);

    // const totatItems = getTotalItems(promos, freeItems);
    const totalItems = useMemo(() => getTotalItems(promos, freeItems), [promos, freeItems]);


    let history = useHistory();

    const actionsStyles = {
        primaryColorHex: flyerBranch?.primaryColorRgb,
        direction: flyerBranch?.dir.toLocaleLowerCase(),
        fontFamily: flyerBranch?.font.toLowerCase(),
        isLightGuiColor: isLightGuiColor,
        fontsGuiColor: fontsGuiColor
    }
    const classes = useStyles(actionsStyles);

    useEffect(() => {
        setPromos(myListState.promos);
        setFreeItems(myListState.benefitItems)
    }, [myListState])

    const resetZooming = () => {
        dispatch(zoomIn({x: 0, y: 0, pivotX: 0, pivotY: 0, scale: 0}));
    }

    const onShareForMobile = () => {
        if (navigator.share) {
            console.log(history);
            const url = new URL(document.location.href);
            url.search = '';
            const search_params = url.searchParams;

            // search_params.set('IsSharedFrom', isMobile ? `mobile` : `desktop`);

            url.search = search_params.toString();

            const new_url = url.toString();
            navigator
                .share({
                    title: flyerBranch?.caption,
                    text: `${shareTextLabel} ${flyerBranch?.caption}`,
                    url: new_url,
                })
                .then(() => {
                    console.log('Successfully shared');
                })
                .catch(error => {
                    console.error('Something went wrong sharing the blog', error);
                });
        }
    }

    const onClickHomeBtn = () => {
        if (flyerBranch?.urls?.accountHomePageUrl) {
            openUrlInAnotherTab(flyerBranch?.urls?.accountHomePageUrl, flyerBranch.caption, "homePage")
        }
    }

    if (isMobile || isPortraitView || isTablet) {
        return (
            <Grid container
                  className={classes.actionsMobileWrapper}
                  justifyContent="center"
                  alignItems="center">
                <Grid item xs={3}>
                    <Box>
                        <Button
                            sx={{opacity: isHelpScreen ? '0.5' : '1'}}
                            title={helpTitle}
                            onClick={() => {
                                resetZooming()
                                dispatch(toggleHelpScreen())
                                if (isTocOpen) {
                                    dispatch(toggleToc())
                                }
                            }}
                        >
                            <QuestionMobile/>
                            <Typography>
                                {helpTitle}
                            </Typography>
                        </Button>
                    </Box>
                </Grid>
                <Grid item xs={3}>
                    <Box>
                        <Button className={`${classes.actionButton} tocActionButton`}
                                sx={{opacity: isTocOpen ? '0.5' : '1'}}
                                disabled={!flyerBranch?.toc?.length}
                            // <button className={`${style.actionsHover}`}
                                title={TocTitle}
                                onClick={() => {
                                    console.log('in');
                                    dispatch(toggleToc())
                                    if (isHelpScreen) {
                                        dispatch(toggleHelpScreen())
                                    }
                                }}
                        >
                            <TocMobile/>
                            <Typography>
                                {contentTitle}
                            </Typography>
                        </Button>
                    </Box>
                </Grid>
                <Grid item xs={3}>
                    <Box>
                        {/*<Typography variant={'h1'} style={{fontFamily: flyerBranch?.font.toLocaleLowerCase()}}>*/}
                        {/*    XC*/}
                        {/*</Typography>*/}
                        <Button className={`${classes.actionButton}`}
                                title={shareTitle}
                                onClick={onShareForMobile}
                        >
                            <ShareIconMobile/>
                            <Typography>
                                {shareTitle}
                            </Typography>
                        </Button>

                    </Box>
                </Grid>
                <Grid item xs={3}>
                    <Box>
                        <Button
                            className={`${classes.actionButton} tocActionButton`}
                            sx={{opacity: isHelpScreen ? '0.5' : '1'}}
                            title={helpTitle}
                            onClick={() => {
                                resetZooming()
                                dispatch(toggleContactUsPopup())
                                if (isTocOpen) {
                                    dispatch(toggleToc())
                                }
                            }}
                        >
                            <XCLogoMobileIcon/>
                            <Typography>
                                {infoTitle}
                            </Typography>
                        </Button>
                    </Box>
                </Grid>
            </Grid>
        )
    } else {
        return (
            <Grid container alignItems={'center'} className={classes.actionDesktopWrapper} columns={12}>
                <Grid item xs>
                    <Grid container justifyContent={'flex-end'} alignItems={'center'} columns={{xs: 24, xl: 36}}>
                        <Grid item xs={4} xl={flyerType !== 1 ? 6 : 4}>
                            <Box className={classes.actionBox} sx={{direction: `ltr`}}>
                                <Button disabled={!flyerBranch?.urls?.accountHomePageUrl}
                                    // <button className={`${style.actionsHover}`}
                                        className={`homeUrl`}
                                        title={flyerBranch?.urls?.accountHomePageUrl ? flyerBranch?.urls?.accountHomePageUrl : ''}
                                        onClick={onClickHomeBtn}
                                >
                                    <GoHomeIcon/>
                                    <Typography>
                                        {homeUrlLabel}
                                    </Typography>
                                </Button>
                            </Box>
                        </Grid>
                        <Grid item xs={4} xl={flyerType !== 1 ? 5 : 4}>
                            <Box className={classes.actionBox}>
                                <Button disabled={!flyerBranch?.toc?.length}
                                    // <button className={`${style.actionsHover}`}
                                        className={`${isTocOpen ? 'isActiveActionBtn' : ''} tocActionButton`}
                                    // title={TocTitle}
                                        onClick={() => {
                                            console.log('in');
                                            dispatch(toggleToc())
                                            if (isHelpScreen) {
                                                dispatch(toggleHelpScreen())
                                            }
                                            if (shareMenu.isOpen) {
                                                dispatch(toggleShareMenu())
                                            }
                                            if (showSearch) {
                                                dispatch(toggleSearch())
                                            }
                                            dispatch(removeSelectedSpot())
                                            if (Boolean(detailsBranch)) {
                                                dispatch(toggleDetailsAction());
                                            }
                                            if (Boolean(addToMyListOneItemData.data)) {
                                                dispatch(setAddToMyListOneItemData(null));
                                            }
                                        }}
                                >
                                    <Toc/>
                                    <Typography>
                                        {contentTitle}
                                    </Typography>
                                </Button>
                            </Box>
                        </Grid>
                        <Grid item xs={4} xl={flyerType !== 1 ? 6 : 4}>
                            <Box className={classes.actionBox}>
                                <Button
                                    // title={fullScreenTitle}
                                    onClick={() => {
                                        resetZooming();
                                        openFullScreen();
                                        if (isTocOpen) {
                                            dispatch(toggleToc())
                                        }
                                        if (isHelpScreen) {
                                            dispatch(toggleHelpScreen())
                                        }
                                        if (shareMenu.isOpen) {
                                            dispatch(toggleShareMenu())
                                        }
                                        if (showSearch) {
                                            dispatch(toggleSearch())
                                        }
                                        if (Boolean(detailsBranch)) {
                                            dispatch(toggleDetailsAction());
                                        }
                                        if (Boolean(addToMyListOneItemData.data)) {
                                            dispatch(setAddToMyListOneItemData(null));
                                        }
                                    }}>
                                    <Fullscreen/>
                                    <Typography>
                                        {fullScreenTitle}
                                    </Typography>

                                </Button>
                            </Box>
                        </Grid>
                        {
                            flyerType !== 1 &&
                            <Grid item xs={4} xl={4}>
                                <Box className={classes.actionBox}>
                                    <Button
                                        // title={searchTitle}
                                        className={showSearch ? 'isActiveActionBtn' : ''}
                                        onClick={() => {
                                            dispatch(toggleSearch())
                                            // console.log(showSearch);
                                            if (isTocOpen) {
                                                dispatch(toggleToc())
                                            }
                                            if (isHelpScreen) {
                                                dispatch(toggleHelpScreen())
                                            }
                                            if (shareMenu.isOpen) {
                                                dispatch(toggleShareMenu())
                                            }
                                            // if (spot?.promoSaleTypeCode === 20 && spot.items.length === 1){
                                            dispatch(removeSelectedSpot())
                                            if (Boolean(detailsBranch)) {
                                                dispatch(toggleDetailsAction());
                                            }
                                            if (Boolean(addToMyListOneItemData.data)) {
                                                dispatch(setAddToMyListOneItemData(null));
                                            }
                                            // }
                                        }}>
                                        <Search/>
                                        <Typography>
                                            {searchTitle}
                                        </Typography>
                                    </Button>
                                </Box>
                            </Grid>
                        }
                        <Grid item xs={4} xl={flyerType !== 1 ? 4 : 3}>
                            <Box className={classes.actionBox}>
                                <Button
                                    className={`${shareMenu.isOpen && shareMenu.shareFor === `forPage` ? 'isActiveActionBtn' : ''} shareBtn`}
                                    // title={helpTitle}
                                    onClick={() => {
                                        resetZooming();
                                        dispatch(toggleShareMenu(`forPage`));
                                        if (isHelpScreen) {
                                            dispatch(toggleHelpScreen())
                                        }
                                        if (isTocOpen) {
                                            dispatch(toggleToc())
                                        }
                                        if (showSearch) {
                                            dispatch(toggleSearch())
                                        }
                                        if (Boolean(detailsBranch)) {
                                            dispatch(toggleDetailsAction());
                                        }
                                        if (Boolean(addToMyListOneItemData.data)) {
                                            dispatch(setAddToMyListOneItemData(null));
                                        }
                                        dispatch(removeSelectedSpot())
                                    }}
                                >
                                    <ShareIcon/>
                                    <Typography>
                                        {shareTitle}
                                    </Typography>
                                </Button>
                            </Box>
                        </Grid>
                        <Grid item xs={4} xl={flyerType !== 1 ? 4 : 3}>
                            <Box className={classes.actionBox}>
                                <Button
                                    className={isHelpScreen ? 'isActiveActionBtn' : ''}
                                    // title={helpTitle}
                                    onClick={() => {
                                        resetZooming()
                                        dispatch(toggleHelpScreen())
                                        if (shareMenu.isOpen) {
                                            dispatch(toggleShareMenu())
                                        }
                                        if (isTocOpen) {
                                            dispatch(toggleToc())
                                        }
                                        if (showSearch) {
                                            dispatch(toggleSearch())
                                        }
                                        if (Boolean(detailsBranch)) {
                                            dispatch(toggleDetailsAction());
                                        }
                                        if (Boolean(addToMyListOneItemData.data)) {
                                            dispatch(setAddToMyListOneItemData(null));
                                        }
                                        dispatch(removeSelectedSpot())
                                    }}
                                >
                                    <Question/>
                                    <Typography>
                                        {helpTitle}
                                    </Typography>
                                </Button>
                            </Box>
                        </Grid>
                    </Grid>
                </Grid>
                {flyerType !== 1 &&
                    <Grid item xs={6} md={5} xl={4}>
                        <Box className={`${classes.actionBox}`} sx={{justifyContent: `flex-end`}}>
                            <Button
                                className={`${showBasket ? 'isActiveActionBtn' : ''} ${classes.myBasketButton}`}
                                // title={`${myBasketTitle} (${getTotalItems(promos, freeItems)})`}
                                onClick={() => {
                                    if (isTocOpen) {
                                        dispatch(toggleToc());
                                    }
                                    if (isHelpScreen) {
                                        dispatch(toggleHelpScreen());
                                    }
                                    if (showSearch) {
                                        dispatch(toggleSearch());
                                    }
                                    if (Boolean(spot)) {
                                        dispatch(removeSelectedSpot());
                                    }
                                    if (shareMenu.isOpen) {
                                        dispatch(toggleShareMenu())
                                    }
                                    if (Boolean(detailsBranch)) {
                                        dispatch(toggleDetailsAction());
                                    }
                                    if (Boolean(addToMyListOneItemData.data)) {
                                        dispatch(setAddToMyListOneItemData(null));
                                    }

                                    if (Boolean(spot) || showSearch || isHelpScreen || isTocOpen || shareMenu.isOpen) {
                                        dispatch(toggleBasket(true));
                                    } else {
                                        dispatch(toggleBasket());

                                    }
                                    //
                                    // dispatch(removeSelectedSpot());
                                    // dispatch(toggleBasket());
                                }}>
                                <Box sx={{position: `relative`}} mx={`20px`}>
                                    <Basket/>
                                    <Box className={classes.numberOfMyListItems}>
                                        <Typography
                                            sx={{
                                                fontSize: `14px`,
                                                lineHeight: `1`,
                                                margin: `2px`,
                                                textAlign: `center`
                                            }}
                                        >
                                            {totalItems}
                                        </Typography>
                                    </Box>
                                </Box>
                                <Typography>
                                    {myBasketTitle}
                                </Typography>
                            </Button>
                        </Box>
                    </Grid>
                }
            </Grid>
        )
    }
}